// Filename: public/shareMyReportV1.js
import wixData from 'wix-data';
import { authentication } from 'wix-members-frontend';
import wixLocationFrontend from "wix-location-frontend";
import wixWindow from 'wix-window';
import { currentMember } from 'wix-members';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';
import { getQuizName } from 'public/surveyManager.js';
import { customLoginOrSignup } from 'public/customSignUpLogin';

let isReachedReportEnd = false;

//------- Code when user click on share my report btn starts -------//
export async function shareMyReportBtnClicks() {
    let currentQuizName = await getQuizName();
    let shareReportQuizURL = await generateShareReportURL();

    $w("#shareMyReport").onClick(async (event) => {

        const isLoggedIn = authentication.loggedIn();
        if (isLoggedIn) {
            let shareMyReportId = await generateShareMyReportId();
            let queryParam = `?shareMyReport=${shareMyReportId}`;
            let shareMyReportFullURL = shareReportQuizURL + queryParam;
            const accessCode = Math.floor(1000 + Math.random() * 9000);

            const dataToSend = {
                //quizName: currentQuizName,
                shareReportQuizURL: shareMyReportFullURL,
                accessCode: accessCode,
                shareMyReportId: shareMyReportId,
                saveCTAction: saveCTAction
            }
            wixWindow.openLightbox('Share My Report V1', dataToSend);
        } else {
            /*21-May-2025 wixWindow.openLightbox('SIGN UP', {
                    value: "signup",
                })
                .then((receivedData) => {
                    if (receivedData) {
                        console.log('receivedData...', receivedData);
                        $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                    }
                }) 21-May-2025 */
                customLoginOrSignup('signup');
        }
        saveCleverTapEvent('Clicked Share My Report', {
            "QuizName": currentQuizName,
        });

    })

    $w("#mobShareMyReportBtn").onClick(async (event) => {
        try {
            let ctProperties = {};
            const isLoggedIn = authentication.loggedIn();
            let shareMyReportId = await generateShareMyReportId();
            let queryParam = `?shareMyReport=${shareMyReportId}`;
            let shareMyReportFullURL = shareReportQuizURL + queryParam;
            const accessCode = Math.floor(1000 + Math.random() * 9000);

            if (wixLocationFrontend.url.includes("minimal=yes") || isLoggedIn) {
                $w('#SMRQuizName').value = currentQuizName;
                $w('#SMRQuizURL').value = shareMyReportFullURL;
                $w('#SMRAccessCode').value = accessCode;
                await insertShareMyReportData(currentQuizName, shareMyReportFullURL, accessCode, shareMyReportId);
            } else {
                /*21-May-2025 
                wixWindow.openLightbox('SIGN UP', {
                        value: "signup",
                    })
                    .then((receivedData) => {
                        if (receivedData.userEmail) {
                            $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                        }
                    })
                    21-May-2025*/
                    customLoginOrSignup('signup');
            }
            if (wixLocationFrontend.url.includes("minimal=yes")) {
                let shareMessage = `I just took the ${currentQuizName} and received a free personalized guidance report that I'm excited to share with you! \n \nYou'll need this access code: ${accessCode} \n \nUse this link to view my report: ${shareMyReportFullURL}. \n \nThe link is active for the next 14 days. I think you'll find it fascinating - it's a great way to better understand me.`
                console.log('shareMessage:-', shareMessage)
                ctProperties["shareMessage"] = shareMessage;
            }
            ctProperties["QuizName"] = currentQuizName;
            saveCleverTapEvent('Clicked Share My Report', ctProperties);
            // saveCleverTapEvent('Clicked Share My Report', {
            //     "QuizName": currentQuizName,
            // });

        } catch (error) {
            console.log('Error in mobShareMyReportBtn', error);
        }

    })
}

async function generateShareReportURL() {
    return new Promise((resolve) => {
        let quizURL = wixLocationFrontend.url;
        let splitURL = quizURL.split('?')[0];
        //console.log('Split Share Quiz URL', splitURL);
        resolve(splitURL);
    })
}

async function generateShareMyReportId() {
    return new Promise((resolve) => {
        const shareMyReportId = Math.floor(new Date().valueOf() * Math.random());
        resolve(shareMyReportId);
    })
}

async function getCurrentMemberDetails() {
    return new Promise((resolve) => {
        currentMember.getMember()
            .then((member) => {
                let currentMemberData = member;
                resolve(currentMemberData);
            })
    })
}

export async function insertShareMyReportData(quizName, quizURL, accessCode, shareMyReportId) {
    try {
        const memberData = await getCurrentMemberDetails();
        const currentDate = new Date();
        let memberEmail = memberData.loginEmail;
        //let supporterName = $w("#supporterName").value;

        return new Promise((resolve) => {
            let toInsert;
            toInsert = {
                "memberFirstName": memberData.contactDetails.firstName,
                "memberLastName": memberData.contactDetails.lastName,
                "memberName": memberData.contactDetails.firstName + ' ' + memberData.contactDetails.lastName,
                "memberEmail": memberEmail,
                "dateShared": currentDate,
                "report": quizURL,
                "quiz": quizName,
                "accessCode": accessCode,
                "shareMyReportId": shareMyReportId
            }
            wixData.insert("ShareMyReport", toInsert)
                .then(async (item) => {
                    console.log("Data saved successfully...", item);
                    resolve();
                })
                .catch((err) => {
                    console.log("Sorry! An error occured", err);
                });
        })

    } catch (error) {
        console.log('Error in insertShareMyReportData', error);
    }

}

export function saveCTAction(eventName, eventData) {
    saveCleverTapEvent(eventName, eventData);
}
//------- Code when user click on share my report btn ends -------//

//------- Code when supporter views report starts -------//

export async function getAndMatchAccessCode(Id) {
    try {
        let result = await wixData.query("ShareMyReport").eq('shareMyReportId', parseInt(Id)).limit(1).find();
        //console.log("getAndMatchAccessCode", result);
        return result.items;
    } catch (e) {
        console.log("getAndMatchAccessCode Error", e)
        return [];
    }
}

export async function setShareMyReportInfoBar(shareMyReportId) {
    try {
        let shareReportDataArray = await getAndMatchAccessCode(shareMyReportId);
        let shareReportData = shareReportDataArray.length > 0 ? shareReportDataArray[0] : null;
        $w('#shareMyReportInfoBox').expand();
        $w("#shareMyReportInfoText").text = `${shareReportData.memberFirstName}'s ${shareReportData.quiz} Guidance`;
        console.log("shareReportData", $w("#shareMyReportInfoText").text);
    } catch (error) {
        console.log('Error in setShareMyReportInfo', error);
    }
}

export function openAccessCodeViewModal(isShareMyReport) {
    wixWindow.openLightbox('Share My Report V1', {
        value: "accesscode",
        shareMyReportId: isShareMyReport,
        saveCTAction: saveCTAction
    })
    .then((data) => {
        console.log('Lightbox data:', data);

        // Redirect if access expired
        if (data && data.action === "accessExpired") {
            wixLocationFrontend.to("/my-journey");
            return;
        }

        // If data is not valid, reopen the lightbox
        if (!data) {
            openAccessCodeViewModal(isShareMyReport); // Recursive call
            return;
        }

        // If data is valid, finish flow
        reachedReportEnd();
    })
    .catch((error) => {
        console.error('Error in lightbox:', error);
        // Retry on error too, optionally
        openAccessCodeViewModal(isShareMyReport);
    });
}

function reachedReportEnd() {
    $w("#reachedReportEnd").onViewportEnter((event) => {
        //wixWindow.openLightbox("Reached Report End");
        if (!isReachedReportEnd) {
            wixWindow.openLightbox("Reached Report End");
            isReachedReportEnd = true;

            // Start cooldown only after popup is triggered
            setTimeout(() => {
                isReachedReportEnd = false;
            }, 1000 * 60); // 60 seconds
        }
    });
}
//------- Code when supporter views report ends -------//